export const handleBodyLock = () => {
  setTimeout(() => {
    if ('bodyScrollFix' in document.body.dataset && !Object.hasOwn(document.body.dataset, 'bodyScrollFix')) {
      const scrollPosition = window.scrollY || document.documentElement.scrollTop;
      document.body.dataset.bodyScrollFix = scrollPosition;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollPosition + 'px';
      document.body.style.left = '0';
      document.body.style.width = '100%';
    }
  }, 15);
};
